module.exports = __webpack_public_path__ + "img/cp3-9.5904fe7b.jpg";